import { wireDatePicker } from "../../../shared/date_picker";

document.addEventListener('alpine:init', () => {
  Alpine.data('AudienceProfileDatePicker', () => ({
    pickerApi: null,
    init() {
      const root = this.$el || document;
      const input = root.querySelector('#audience-range');
      const clearBtn = root.querySelector('#audience-clear');
      const fromEl = root.querySelector('#audience_from');
      const toEl = root.querySelector('#audience_to');

      const onChange = (payload) => {
        try {
          const event = new CustomEvent('audience-range-change', { detail: payload });
          window.dispatchEvent(event);
        } catch (_) {}
        this.syncClearVisibility();
      };

      this.pickerApi = wireDatePicker({
        rootEl: root,
        onChange,
        inputSelector: '#audience-range',
        // No preset buttons for audience profile custom range
        buttonSelector: '[data-chart-type="audience"][data-range] = none',
        hiddenFromSelector: '#audience_from',
        hiddenToSelector: '#audience_to',
        maxDate: 'today',
        activeClasses: { add: ['bg-quill-100'], remove: ['bg-white'] }
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', () => {
          try {
            if (input && typeof input.value !== 'undefined') input.value = '';
            if (fromEl) fromEl.value = '';
            if (toEl) toEl.value = '';
          } catch (_) {}
          try { this.pickerApi && this.pickerApi.setActive && this.pickerApi.setActive(null); } catch (_) {}
          this.syncClearVisibility();
          try { window.dispatchEvent(new CustomEvent('audience-range-change', { detail: { type: 'clear' } })); } catch (_) {}
        });
      }

      if (input) {
        input.addEventListener('input', () => this.syncClearVisibility());
        input.addEventListener('change', () => this.syncClearVisibility());
        setTimeout(() => this.syncClearVisibility(), 0);
      }
    },
    syncClearVisibility() {
      try {
        const input = (this.$el || document).querySelector('#audience-range');
        const clearBtn = (this.$el || document).querySelector('#audience-clear');
        if (!input || !clearBtn) return;
        const show = Boolean(input.value && input.value.trim().length > 0);
        if (show) clearBtn.classList.remove('hidden');
        else clearBtn.classList.add('hidden');
      } catch (_) {}
    },
    destroy() {
      try { this.pickerApi && this.pickerApi.destroy && this.pickerApi.destroy(); } catch (_) {}
      this.pickerApi = null;
    }
  }));
});

